import { z } from "zod";

/**
 * Le contrat des reglages des overlays d'OBS (ticket 3 du TCG, PR 7) : ce que la regie regle sous
 * `/api/direct/qr` et ce qu'un overlay relit sous `/api/overlay/reglages`. Re-exporte par `direct.ts`.
 *
 * Pour l'instant un seul reglage, celui du QR code de `/overlay/taverne` : le coin de l'ecran ou il se pose, et
 * s'il se montre. Les reglages d'un overlay vivent sous une cle a son nom (`qr`), pour que les suivants (le
 * ticket 9 fera grandir cet overlay) s'y ajoutent sans changer la forme de ce qui existe.
 */

/** Les quatre coins ou le QR code peut se poser, dans l'ordre de l'ecran de la regie. */
export const COINS_QR = ["haut-gauche", "haut-droit", "bas-gauche", "bas-droit"] as const;
export const coinQrSchema = z.enum(COINS_QR);
export type CoinQr = z.infer<typeof coinQrSchema>;

/**
 * Le reglage du QR code : le coin ou il se pose, et s'il se montre au stream. Il part cache : rien n'apparait
 * a l'ecran tant que Nicolas ne l'allume pas.
 */
export const reglageQrSchema = z.object({ coin: coinQrSchema, visible: z.boolean() });
export type ReglageQr = z.infer<typeof reglageQrSchema>;

/** `GET /api/overlay/reglages` : les reglages qu'un overlay lit a l'ouverture, a chaque reconnexion et a chaque `reprise`. */
export const reglagesOverlaySchema = z.object({ qr: reglageQrSchema });
export type ReglagesOverlay = z.infer<typeof reglagesOverlaySchema>;
